import { gql } from '@grandvisionhq/graphql';

const availableShippingMethod = gql`
  fragment AvailableShippingMethodFragment on AvailableShippingMethod {
    id
    key
    label {
      locale
      value
    }
    price
    freeAbove
    isDefault
  }
`;

export { availableShippingMethod };
//# sourceMappingURL=shipping-method.js.map
